import { Component, input } from '@angular/core';
import { AdminIconComponent } from './admin-icon.component';
import type { LucideIconInput } from '@lucide/angular';

@Component({
  selector: 'app-admin-empty-state',
  standalone: true,
  imports: [AdminIconComponent],
  template: `
    <div class="cg-admin-empty">
      @if (icon(); as iconName) {
        <span class="cg-admin-empty__icon" aria-hidden="true">
          <app-admin-icon [name]="iconName" [size]="40" />
        </span>
      }
      @if (title()) {
        <p class="cg-admin-empty__title">{{ title() }}</p>
      }
      @if (description()) {
        <p class="cg-admin-empty__desc">{{ description() }}</p>
      }
      <ng-content />
    </div>
  `,
})
export class AdminEmptyStateComponent {
  readonly icon = input<LucideIconInput>();
  readonly title = input<string>();
  readonly description = input<string>();
}
